import React, {useState, useEffect} from 'react';
import {Td, Avatar, Flex} from "@chakra-ui/react";
import useWorkspaceStore from "../../store/useWorkspaceStrore.ts";
import {IWorkspaceMember} from "../../models/interfaces/workspaceMember.interface.ts";

interface ProjectTableCreatedByColumnProps {
  createdById: string;
}

const ProjectTableCreatedByColumn: React.FC<ProjectTableCreatedByColumnProps> = ({createdById}) => {
  const [member, setMember] = useState<IWorkspaceMember | null>(null);

  const {getMember} = useWorkspaceStore();

  useEffect(() => {
    const fetchMember = async () => {
      try {
        const fetchedMember: IWorkspaceMember = await getMember(createdById);
        setMember(fetchedMember);
      } catch (err) {
        console.error("Failed to fetch member:", err);
      }
    };

    fetchMember().then(() => null);
  }, [createdById, getMember]);

  return (
    <Td textAlign="left">
      <Flex align="center" justify="center" gap="3">
        <Avatar
          size="sm"
          name={`${member?.firstName} ${member?.lastName}`}
          src={member?.imageSasLink}
          border="1px solid transparent"
        />
      </Flex>
    </Td>
  );
};

export default ProjectTableCreatedByColumn;